import { LanguageConst } from '../../../utils/resources/languageconst';
import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../uicomponentcss';

export interface ErrorAlertCSSStyle extends UIComponentCSSStyle{
    getInnerWrapperCSSStyle():object;
    getCloseButtonDivCSSStyle():object;
    getAlertImageDivCSSStyle():object;
    getAlertMessageDivCSSStyle():object;
    getButtonDivCSSStyle():object;
    getMobileAlertImageDivCSSStyle():object;
    getMobileAlertMessageDivCSSStyle():object;
    getMobileWrapperCSSStyle():object;
    getMobileCloseButtonDivCSSStyle():object;

}
export class ErrorAlertCSSStyleImpl extends UIComponentCSSStyleImpl implements ErrorAlertCSSStyle
{
    getWrapperCSSStyle():object
    {
        return{
            width:'440px',
            display:'flex', 
            height:'617px',
            borderRadius:'8px', 
            backgroundColor:'#E21736'
        };
    }


    getInnerWrapperCSSStyle():object
    {
        return{
            width:'100%', height:'100%'
        };
    }
    getCloseButtonDivCSSStyle():object
    {
        return{
            width:'100%',
            marginTop:'17px', 
            height:'20px',
            paddingRight:'20px',
            textAlign:"right",
            // marginLeft:'403px',
            // display:"inline-block",
            cursor:'pointer'

        };
    }

    getMobileCloseButtonDivCSSStyle():object
    {
        return{
            width:'100%',
            marginTop:'17px', 
            height:'20px',
            paddingRight:'20px',
            // marginLeft:'260px',
            textAlign:"right",
            cursor:'pointer'

        };
    }

    getMobileWrapperCSSStyle():object
    {
        return{
            width:'auto',
            display:'flex', 
            height:'440px',
            borderRadius:'8px', 
            backgroundColor:'#E21736'
        };
    }
    getMobileAlertImageDivCSSStyle():object
    {
        return{
            width:'100%',
            marginTop:'50px', 
            height:'70px',
            // marginLeft:'120px',
            marginBottom:'50px',
            textAlign:'center'
        };
    }

    getMobileAlertMessageDivCSSStyle():object
    {
        return{
            width:'auto',
            margin:'0px 43px 90px 43px',
            textAlign:'center', 
            height:'60px',
            fontFamily:this.getResources().getFontFamily(), 
            fontSize:this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ? '22px' : '14px',
            fontWeight:900,
            color:'#FFFFFF',
            lineHeight:'30px',
            letterSpacing:'0'
        };
    }

    getAlertImageDivCSSStyle():object
    {
        return{
            width:'100%',
            marginTop:'102px', 
            height:'150px',
            // marginLeft:'144.5px',
            marginBottom:'50px',
            textAlign:'center'
        };
    }

    getAlertMessageDivCSSStyle():object
    {
        return{
            width:'auto',
            margin:'0px 86px 132px 86px',
            textAlign:'center', 
            height:'60px',
            fontFamily:this.getResources().getFontFamily(), 
            fontSize:this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ? '25px' : '22px',
            fontWeight:900,
            color:'#FFFFFF',
            lineHeight:'30px',
            letterSpacing:'0'
        };
    }

    getButtonDivCSSStyle():object
    {
        return{
            margin:'0px 140px 40px 140px',
            // color:'#E21736'
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/alert/erroralertcss.tsx